
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const formatTime = (time) => {
    if (time === null || time === undefined) return ""; // Mostrar cadena vacía si el tiempo es null
    const hours = Math.floor(time / 3600).toString().padStart(2, '0');
    const minutes = Math.floor((time % 3600) / 60).toString().padStart(2, '0');
    const seconds = (time % 60).toString().padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  };

export const exportToExcel = async (schedules) => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Horarios");

    // Estilos globales
    const primaryColor = "0074FF"; // Color principal

    const titleStyle = {
        font: { bold: true, size: 16, color: { argb: "FFFFFF" } },
        alignment: { horizontal: "center" },
        fill: { type: "pattern", pattern: "solid", fgColor: { argb: primaryColor } },
    };

    const headerStyle = {
        font: { bold: true, size: 12, color: { argb: "FFFFFF" } },
        alignment: { horizontal: "center" },
        fill: { type: "pattern", pattern: "solid", fgColor: { argb: primaryColor } },
    };

    const rowStyleEven = {
        fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6F0FF" } }, // Azul claro
    };

    const rowStyleOdd = {
        fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } }, // Blanco
    };

    let currentRow = 1;

    schedules.forEach((schedule, scheduleIndex) => {
        // Título del horario
        sheet.mergeCells(currentRow, 1, currentRow, schedule.turns[0]?.length || 1);
        const titleCell = sheet.getCell(currentRow, 1);
        titleCell.value = schedule.name;
        titleCell.style = titleStyle;
        currentRow++;

        // Encabezados
        const headers = schedule.turns[0]?.map((point) => point.label) || [];
        headers.forEach((header, colIndex) => {
            const cell = sheet.getCell(currentRow, colIndex + 1);
            cell.value = header;
            cell.style = headerStyle;
        });
        currentRow++;

        // Filas del cuerpo
        schedule.turns.forEach((lap, lapIndex) => {
            lap.forEach((point, colIndex) => {
                const cell = sheet.getCell(currentRow, colIndex + 1);
                cell.value = formatTime(point.time);
                cell.style = lapIndex % 2 === 0 ? rowStyleEven : rowStyleOdd; // Alternar colores
            });
            currentRow++;
        });

        // Espacio en blanco entre tablas
        if (scheduleIndex < schedules.length - 1) {
            currentRow++;
        }
    });

    // Ajustar columnas automáticamente
    sheet.columns.forEach((column) => {
        column.width = 15; // Ancho estándar
    });
    
    // Exportar archivo
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), schedules.length > 1 ? "Horarios.xlsx" : schedules[0].name === "[Nombre del horario]" ? 'Horario - Plantilla.xlsx' : `${schedules[0].name}.xlsx`);
};